import InvitationsScreen from './InvitationsScreen';

export const BenchmarkInvitationsScreen = (props: any) => (
  <InvitationsScreen {...props} sessionType="benchmarks_sprint" />
);

export default BenchmarkInvitationsScreen;
